import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';

class Modal {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.elem.addEventListener('shown.bs.modal', function () {
            console.log('here');
        })
    };
}

export default Modal;
